import * as Yup from 'yup';
import Link from 'next/link';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useFormik } from 'formik';
import { useRouter } from 'next/router';

import NavLink from '../nav-link';
import menuIcon from '../../assets/images/icon-menu.svg';
import closeIcon from '../../assets/images/icon-close.svg';
import logoImg from '../../assets/images/kecobo-logo.png';
import searchIcon from '../../assets/images/icon-search.svg';
import notificationIcon from '../../assets/images/icon-notification.svg';

const StyledInput = styled.input.attrs({
  className: 'search-input md:max-w-3xl bg-gray-300 py-3 px-5',
})`
  background-image: url('${searchIcon}');
`;

type HeaderProps = {
  signout: () => void;
  isLoggedIn: boolean;
};

interface FormValues {
  search: string;
}

export const Header: React.FC<HeaderProps> = (props) => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const { q: term = '' } = router.query;
  const initialValues: FormValues = { search: term as string };

  const formik = useFormik({
    initialValues,
    onSubmit: ({ search }) => {
      const query = { q: search };
      router.push({ pathname: '/search', query });
    },
    validationSchema: Yup.object().shape({
      search: Yup.string().required('Search term is required'),
    }),
  });

  const _handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    formik.submitForm();
  };

  const { values, handleChange } = formik;

  return (
    <div className="w-full px-4 py-2 max-width">
      <div className="flex items-center">
        <div className="block w-6 cursor-pointer sm:hidden" onClick={() => setIsOpen(!isOpen)}>
          <img src={isOpen ? closeIcon : menuIcon} alt="" />
        </div>

        <div className="hidden w-10 sm:block sm:w-12">
          <Link href={props.isLoggedIn ? '/dashboard' : '/'}>
            <a>
              <img src={logoImg} alt="Logo" />
            </a>
          </Link>
        </div>

        <div className="flex-1 px-4">
          <form onSubmit={_handleSubmit}>
            <StyledInput
              type="text"
              name="search"
              value={values.search}
              onChange={handleChange}
              placeholder="Search Copyrights Database..."
            />
          </form>
        </div>

        <div className="sm:px-4">
          <img src={notificationIcon} alt="" />
        </div>

        {props.isLoggedIn && (
          <div className="hidden pl-4 sm:block">
            <button
              className="float-right px-6 py-3 text-white rounded-lg bg-secondary focus:bg-red-500"
              type="button"
              onClick={props.signout}
            >
              Logout
            </button>
          </div>
        )}
      </div>

      <div
        className={`overflow-hidden is-expanded ${
          isOpen ? 'h-48 border-top mt-3 pt-3 pb-1' : 'h-0'
        }`}
      >
        <NavLink href="/dashboard">
          <a className="block px-4 py-3 text-sm font-medium rounded-lg navbar-item sm:py-4">
            <p className="w-full bg-transparent">Dashboard</p>
          </a>
        </NavLink>

        <NavLink href="/copyrights" subRoutes={['/new-copyright']}>
          <a className="block px-4 py-3 mt-3 text-sm font-medium rounded-lg navbar-item sm:py-4">
            <p className="w-full bg-transparent">My Copyrights</p>
          </a>
        </NavLink>

        <NavLink href="/faq">
          <a className="block px-4 py-3 mt-3 text-sm font-medium rounded-lg navbar-item sm:py-4">
            <p className="w-full bg-transparent">FAQs</p>
          </a>
        </NavLink>

        <div className="pt-3 mt-3 border-top">
          <button
            className="float-right px-6 py-3 text-white rounded-lg bg-secondary"
            type="button"
            onClick={props.signout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
